import { render, staticRenderFns } from "./TableRemote.vue?vue&type=template&id=a310a704&"
import script from "./TableRemote.vue?vue&type=script&lang=js&"
export * from "./TableRemote.vue?vue&type=script&lang=js&"
import style0 from "./TableRemote.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Checkbox: require('/home/runner/work/myody_front/myody_front/components/checkbox/Checkbox.vue').default,Input: require('/home/runner/work/myody_front/myody_front/components/input/Input.vue').default,DatePicker: require('/home/runner/work/myody_front/myody_front/components/date/DatePicker.vue').default})
